import React, { memo } from 'react';
import styled, { css } from 'styled-components';
import { INDICATOR_FIXED_DIMENSION_SIZE } from '../constants';
import { tabsTheme } from '../TabsTheme';
const Wrapper = styled.div `
  bottom: 0;
  height: ${({ orientation }) => orientation === 'vertical' ? '100%' : INDICATOR_FIXED_DIMENSION_SIZE};
  left: 0;
  position: absolute;
  ${({ orientation }) => css `
    height: ${orientation === 'vertical'
    ? '100%'
    : INDICATOR_FIXED_DIMENSION_SIZE};
    width: ${orientation === 'vertical'
    ? INDICATOR_FIXED_DIMENSION_SIZE
    : '100%'};
    overflow-x: ${orientation === 'vertical' ? '' : 'hidden'};
  `};
`;
const verticalCss = css `
  height: ${(props) => props.indicatorSize}px;
  width: 100%;
  left: 0;
  transform: translateY(${(props) => props.indicatorPosition}px);
  transition: height 150ms, transform 150ms;
`;
const horizontalCss = css `
  height: 100%;
  width: ${(props) => props.indicatorSize}px;
  transform: translateX(${(props) => props.indicatorPosition}px);
  transition: transform 150ms, width 150ms;
  top: 0;
`;
const IndicatorLine = styled.div `
  ${({ orientation }) => orientation === 'vertical' ? verticalCss : horizontalCss};
  background-color: ${tabsTheme.solid.indicator.color};
  position: absolute;
`;
export const Indicator = styled(
// eslint-disable-next-line react/display-name
memo(({ indicatorPosition, indicatorSize, orientation, className }) => (React.createElement(Wrapper, { orientation: orientation, className: className },
    React.createElement(IndicatorLine, { indicatorSize: indicatorSize, indicatorPosition: indicatorPosition, orientation: orientation }))))) ``;
//# sourceMappingURL=Indicator.js.map